import { Navigate, useLocation } from 'react-router-dom'
import { useHubAuth } from '@/context/HubAuthContext'

export default function ProtectedHubRoute({ children }) {
  const { user, loading } = useHubAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
        Loading…
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/hub/login" replace state={{ from: location.pathname }} />
  }

  return children
}
